<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarSupplierPerformance",
	data: () => ({
		menuItems: [],
		sidebar: false,
	}),
}
</script>
